<!-- info-other apps-->
<div #otherapps class="component-container">

    <!-- language de -->
    <ng-container *ngIf="languageCode==='de'">
        <h1>Weitere Apps von Trip4you</h1>

        <h3>Weitere Apps</h3>
        <div style="margin:0.5em;">
            <span style="font-size: large;"><b>Trip4You - Travel information</b><br>
                App zum Suchen von Reiseinformationen </span><br>
            <p style="margin-left:2.0em; margin-top:0.5rem;">
                Trip4You-Reiseinformationen sind Teil der Reiseplaner-App.<br>
                Sie können es ohne Reiseplanung verwenden, um Reiseinformationen über ein Land oder eine Region zu
                erhalten.
            </p>
            <a mat-raised-button color="primary" href="https://trip4you.net/explore" target="_blank"
                style="margin-left:2.0em;">Trip4You - Travel information</a>
        </div>
        <div style="margin:0.5em;">
            <span style="font-size: large;"><b>Trip4You - Travel planner</b><br>
                App zum Planen von individuellen Reisen</span><br>
            <p style="margin-left:2.0em; margin-top:0.5rem;">
                Mit dem Reiseplaner Trip4You können Sie alle Ihre Reisen mit allen gewünschten Detailinformationen
                planen. <br>
                Zu Ihrer Reise können Sie die Orte, die Sie besuchen möchten, die Transfers von einem Ort zum anderen
                und vieles mehr hinzufügen
                Weitere Informationen.<br>
                Für jeden Ort, den Sie hinzugefügt haben, können Sie die Dinge speichern, die Sie sehen und unternehmen
                möchten. Zusätzlich können sie Unterkünfte
                und Restaurants, Infos und Links zu den Orten hinzufügen.
            </p>
            <a mat-raised-button color="primary" href="https://trip4you.net/planner" target="_blank"
                style="margin-left:2.0em;">Trip4You - Travel planner</a>
        </div>
    </ng-container>

    <!-- language en -->
    <ng-container *ngIf="languageCode!=='de'">

        <h3>There are more apps available</h3>
        <div style="margin:0.5em;">
            <span style="font-size: large;"><b>Trip4You - Travel information</b><br>
                App for travel information</span><br>
            <p style="margin-left:2.0em; margin-top:0.5rem;">
                Trip4You travel information is part of the trip planner app.<br>
                You can use it without planning a trip to get travel information about a country or region.
            </p>
            <a mat-raised-button color="primary" href="https://trip4you.net/explore" target="_blank"
                style="margin-left:2.0em;">Try Trip4You - Travel information</a>
        </div>
        <div style="margin:0.5em;">
            <span style="font-size: large;"><b>Trip4You - Travel planner</b><br>
                App for individual trip planning</span><br>
            <p style="margin-left:2.0em; margin-top:0.5rem;">
                With Trip4You travel planner you can plan all your trips with all detailed information you like. <br>
                To your trip you can add the places you want to visit, the transfers from one place to another and much
                additional information.<br>
                For each place you've added, you can save the things you want to see and do. Additionally you can add
                your accommodations
                and restaurants, information and links to the places.
            </p>
            <a mat-raised-button color="primary" href="https://trip4you.net/planner" target="_blank"
                style="margin-left:2.0em;">Try Trip4You - Travel planner</a>
        </div>

    </ng-container>

</div>